import { config } from '@psl/functions/config';
import { ReactNode, Suspense } from 'react';
import { StatsigProvider as ExpoStatsigProvider } from 'statsig-react-native-expo';
import { useInitStatsigUser } from '../functions/abtest/useStatsig';
import {
  LaunchTrackBeginSpan,
  LaunchTrackEndSpan,
} from '../functions/appLaunchTracking';

export const WiredStatsigProvider = ({ children }: { children: ReactNode }) => {
  return (
    <Suspense fallback={null}>
      <LaunchTrackBeginSpan name="statsig-initialization">
        <StatsigProvider>{children}</StatsigProvider>
      </LaunchTrackBeginSpan>
    </Suspense>
  );
};

const StatsigProvider = ({ children }: { children: ReactNode }) => {
  const initStatsigUser = useInitStatsigUser();

  return (
    <ExpoStatsigProvider
      sdkKey={config.statsigSdkKey}
      user={initStatsigUser}
      waitForInitialization={true}
    >
      <LaunchTrackEndSpan name="statsig-initialization">
        {children}
      </LaunchTrackEndSpan>
    </ExpoStatsigProvider>
  );
};
